import { AicSetSyncModeBucket, CommonaicGetSsoUrlResponse, LandingPageEnum } from '@/types/api'
import networkTS from './networkTS'

function normalizeSsoUrl(url?: string): string | null {
  if (!url) {
    return null
  }
  if (/^https?:\/\//i.test(url)) {
    return url
  }
  const baseUrl = (process.env.VUE_APP_BASE_API_URL || '').replace(/\/$/, '')
  if (!baseUrl) {
    return null
  }
  return `${baseUrl}${url.startsWith('/') ? url : `/${url}`}`
}

export default {
  hasAicEnabled(accountId: string) {
    return networkTS.aicServiceHasAicEnabled(accountId)
      .then((response) => {
        return response.data
      })
  },
  enableAic(accountId: string, enable: boolean) {
    return networkTS.aicServiceEnableAic({ accountId: accountId, enable: enable })
      .then((response) => {
        return response.data
      })
  },
  setSyncModeForProperties(accountId: string, buckets: AicSetSyncModeBucket[]) {
    return networkTS.aicServiceSetSyncModeForProperties({
      accountId,
      buckets
    })
      .then((response) => {
        return response.data
      })
  },
  getSsoUrl(landingPage: LandingPageEnum, entityId?: string, ticketId?: string) {
    return networkTS.aicServiceGetSsoUrl({
      landingPage: landingPage,
      entityId: entityId,
      ticketId: ticketId
    })
      .then((response) => {
        const data = response.data
        return {
          ...data,
          url: normalizeSsoUrl(data?.url) || data?.url
        }
      })
  },
  openSsoUrl(response: CommonaicGetSsoUrlResponse) {
    const url = normalizeSsoUrl(response?.url)
    if (!url) {
      return false
    }
    window.open(url, '_blank', 'noopener,noreferrer')
    return true
  },
  getSyncModeForProperty(propertyId: string) {
    return networkTS.aicServiceGetSyncModeForAccountsByPropertyId(propertyId, {})
      .then(response => {
        return response.data
      })
  }
}
